app.service('imageService', function($rootScope,preloader) {

    var preloadStack = [],
        imagePath = '/themes/designwebben/img/design',
        preloadDone = false

    this.preload = function(item,secondary){
        var key = secondary ? 'secondary_image' : 'primary_image';
        if(item.media && item.media[key]){
             preloadStack.push(item.media[key].url);
             return item.media[key].url;
        }
    };

    this.preloadFromUrl = function(url){
        preloadStack.push(url);
    }

    this.run = function(){
        return preloader.preloadImages(preloadStack);
    };

    this.isPreloadDone = function() {
        return preloadDone
    }

    this.preloadDone = function() {
        preloadDone = true
    }
});
